export default __webpack_public_path__ + "static/media/walmart.ac1b2814.png";